const brand = {
  brandProfile: "Brand Profile",
  companyName: "Company Name",
  uploadLogo: "Upload Logo",
  removeLogo: "Remove Logo",
  tagline: "Digital Signature",
  brandColors: "Brand Colors",
  primary: "Primary",
  secondary: "Secondary",
  tertiary: "Tertiary",
  brand: "Brand",
} as const;
export default brand;
